module.exports = __webpack_public_path__ + "img/ethernal.0f3f96a5.svg";